import { create } from 'zustand'

interface StepperState {
  activeStep: number
  completed: boolean[]
  disabled: boolean[]
  isCompleted: boolean
  setActiveStep: (activeStep: number) => void
  setCompleted: (completed: boolean[]) => void
  setDisabled: (disabled: boolean[]) => void
  setIsCompleted: (isCompleted: boolean) => void
  resetStepper: () => void
}

export const useStepperStore = create<StepperState>(set => ({
  activeStep: 0,
  completed: [],
  disabled: [],
  isCompleted: false,
  setActiveStep: activeStep => {
    set({ activeStep })
  },
  setCompleted: completed => {
    set({ completed })
  },
  setDisabled: disabled => {
    set({ disabled })
  },
  setIsCompleted: isCompleted => {
    set({ isCompleted })
  },
  resetStepper: () => {
    set({ activeStep: 0, completed: [], disabled: [], isCompleted: false })
  },
}))
